<template>
  <div class="rust-task-detail">
    <common-bg-plate>
      <div class="title-bar">
        <div class="title-bar-space"></div>
      </div>
      <detail-table :title="title1" :table-col="tableCol1" :list="taskInfo">
        <template #actions>
          <btn-style :btn-list="btnList"></btn-style>
        </template>
      </detail-table>
      <detail-table :title="title2" :table-col="tableCol2" :list="taskInfo">
        <template slot="labels" slot-scope="{ param }">
          <div>
            <div v-if="!param || param.length == 0" class="content">
              {{ $constants.EMPTY }}
            </div>
            <div v-else class="labels">
              <el-tag v-for="(item, index) in param" :key="index" type="info">{{ item }}</el-tag>
            </div>
          </div>
        </template>
        <template slot="switch" slot-scope="{ param }">
          <el-switch v-model="param.value" :disabled="true"></el-switch>
        </template>
      </detail-table>
      <detail-table :title="title3" :table-col="tableCol3" :list="taskInfo" :show-border="true">
        <template slot="command" slot-scope="{ param }">
          <el-alert :closable="false" :title="param" type="default"></el-alert>
        </template>
        <template slot="result" slot-scope="{ param }">
          <div class="result-list">
            <el-alert v-for="(item, index) in param" :key="index" :closable="false" :title="item"
              type="default"></el-alert>
          </div>
        </template>
      </detail-table>
    </common-bg-plate>
    <restart-rust-detector-task :task-info="taskInfo" :dialog-visible.sync="showRestartRustDetectorTask"
      @restartSuccess="onRestartTaskSuccess"></restart-rust-detector-task>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import restartRustDetectorTask from './restartRustDetectorTask'
import idIconImg from '@/assets/images/tableIcon/id-icon.png'
import nameImg from '@/assets/images/tableIcon/contract-name.png'
import timeImg from '@/assets/images/tableIcon/time.png'
import addTimeImg from '@/assets/images/tableIcon/n-clock-add.png'
import checkTimeImg from '@/assets/images/tableIcon/n-clock-check.png'
import startimeImg from '@/assets/images/tableIcon/n-clock-start.png'
import finishTimeImg from '@/assets/images/tableIcon/n-clock-finish.png'
import durTimeImg from '@/assets/images/tableIcon/n-clock-duration.png'
import taskImg from '@/assets/images/tableIcon/n-task.png'
import taskStatusImg from '@/assets/images/tableIcon/n-task-status.png'
import funcImg from '@/assets/images/tableIcon/n-function.png'
import wastImg from '@/assets/images/tableIcon/n-wast-check.png'
import wasmImg from '@/assets/images/tableIcon/n-wasm-check.png'
import insImg from '@/assets/images/tableIcon/n-instructions.png'
import logImg from '@/assets/images/tableIcon/n-log.png'
import alarmImg from '@/assets/images/tableIcon/n-alarm.png'
import commandImg from '@/assets/images/tableIcon/n-command.png'
import { isNumber } from '@/utils/common'

export default {
  name: 'RustContractDetail',
  components: {
    restartRustDetectorTask
  },
  data() {
    return {
      title1: '任务基本信息',
      tableCol1: [
        { label: '任务ID', icon: idIconImg, value: 'ID' },
        { label: '合约ID', icon: idIconImg, value: 'ContractID' },
        { label: '合约名', icon: nameImg, value: 'ContractFilename' },
        { label: '创建时间', icon: addTimeImg, value: 'CreatedAt', formatter: this.formatTime },
        { label: '更新时间', icon: checkTimeImg, value: 'UpdatedAt', formatter: this.formatTime }
      ],
      title2: '任务配置信息',
      tableCol2: [
        { label: '检测函数名', icon: funcImg, value: 'Functions', slotName: 'labels', span: 24 },
        { label: '指令数量统计', icon: insImg, value: 'CountInstructionValue', slotName: 'switch' },
        { label: 'Wast格式检测', icon: wastImg, value: 'WastValue', slotName: 'switch' },
        { label: 'Wasm格式检测', icon: wasmImg, value: 'WasmValue', slotName: 'switch' }
      ],
      title3: '任务运行详情',
      showRestartRustDetectorTask: false,
      taskInfo: {
        ID: '',
        ContractID: '',
        ContractFilename: '',
        Status: 0,
        CreatedAt: 0,
        StartedAt: 0,
        FinishedAt: 0,
        Functions: [],
        CountInstruction: false,
        Wast: false,
        Wasm: false,
        Status: 0,
        StartedAt: 0,
        FinishedAt: 0,
        CostSec: 0,
        Result: [],
        CountInstructionValue: {},
        WastValue: {},
        WasmValue: {}
      },
      btnList: [
        {
          btnContent: '刷新',
          click: () => {
            return this.getTaskInfo()
          },
          icon: 'icon-refresh',
          type: 'default'
        },
        {
          btnContent: '重新运行',
          click: () => {
            return this.onPopConfirmRestart()
          }
        }
      ]
    }
  },
  computed: {
    tableCol3() {
      if (this.taskInfo.Status == 0 || this.taskInfo.Status == 1) {
        return [
          { label: '任务执行命令', icon: commandImg, value: 'CommandLine', slotName: 'command', span: 24 },
          { label: '任务状态', icon: taskStatusImg, value: 'Status', formatter: this.transStatus },
          {
            label: '任务开始时间',
            icon: startimeImg,
            value: 'StartedAt',
            formatter: this.formatTime
          },
          {
            label: '最近活跃时间',
            icon: alarmImg,
            value: 'LastActiveToNow',
            formatter: this.formatLastActiveTime
          },
          {
            label: '任务耗时',
            icon: durTimeImg,
            value: 'CostSec',
            formatter: this.timeLengthFormat
          },
          { label: '任务日志', icon: logImg, value: 'Result', slotName: 'result', span: 24 }
        ]
      } else {
        return [
          { label: '任务执行命令', icon: commandImg, value: 'CommandLine', slotName: 'command', span: 24 },
          { label: '任务状态', icon: taskStatusImg, value: 'Status', formatter: this.transStatus },
          {
            label: '任务开始时间',
            icon: startimeImg,
            value: 'StartedAt',
            formatter: this.formatTime
          },
          {
            label: '任务结束时间',
            icon: finishTimeImg,
            value: 'FinishedAt',
            formatter: this.formatTime
          },
          {
            label: '任务耗时',
            icon: durTimeImg,
            value: 'CostSec',
            formatter: this.timeLengthFormat
          },
          { label: '任务日志', icon: logImg, value: 'Result', slotName: 'result', span: 24 }
        ]
      }
    }
  },
  mounted() {
    this.getTaskInfo()
  },
  methods: {
    ...mapActions([]),
    getTaskInfo() {
      let self = this
      this.$apis.contractdetector
        .getRustDetectTaskInfo({
          task_id: self.$route.query.taskId
        })
        .then(res => {
          if (res && res.data && res.code === 1) {
            self.taskInfo = res.data
            if (self.taskInfo.Result && (self.taskInfo.Status == -1 || self.taskInfo.Status == 2)) {
              if (self.taskInfo.Result.startsWith('\n')) {
                self.taskInfo.Result = self.taskInfo.Result.substring(1)
              }
              while (self.taskInfo.Result.endsWith('\n')) {
                self.taskInfo.Result = self.taskInfo.Result.substring(
                  0,
                  self.taskInfo.Result.length - 1
                )
              }
              self.taskInfo.Result = self.taskInfo.Result.split('\n').map(e => (e ? e : '-'))
            } else {
              self.taskInfo.Result = []
            }
            self.taskInfo.WasmValue = {
              value: self.taskInfo.Wasm
            }
            self.taskInfo.WastValue = {
              value: self.taskInfo.Wast
            }
            self.taskInfo.CountInstructionValue = {
              value: self.taskInfo.CountInstruction
            }
          }
          // console.log(res)
        })
    },
    formatTime(data, value) {
      let time = data[value];
      if (time) {
        return this.$utils.dateFormat('YYYY-mm-dd HH:MM', new Date(time))
      } else {
        return this.$constants.EMPTY
      }
    },
    formatLastActiveTime(data, value) {
      let time = data[value];
      if (!isNumber(time) || isNaN(time) || time < 0) return this.$constants.EMPTY
      return `${time}s前`
    },
    timeLengthFormat(data, value) {
      let time = data[value];
      if (!isNumber(time) || isNaN(time) || time < 0) return this.$constants.EMPTY
      var secondTime = parseInt(time) // 秒
      var minuteTime = 0 // 分
      var hourTime = 0 // 小时
      if (secondTime > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60)
        //获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60)
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60)
          //获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = parseInt(minuteTime % 60)
        }
      }
      var result = '' + parseInt(secondTime) + '秒'

      if (minuteTime > 0) {
        result = '' + parseInt(minuteTime) + '分' + result
      }
      if (hourTime > 0) {
        result = '' + parseInt(hourTime) + '小时' + result
      }

      return result
    },
    transStatus: function (data, value) {
      let status = data[value];
      if (status == -1) {
        return '任务异常'
      } else if (status == 0) {
        return '创建成功'
      } else if (status == 1) {
        return '正在运行'
      } else if (status == 2) {
        return '任务成功'
      } else {
        return this.$constants.EMPTY
      }
    },
    onPopConfirmRestart() {
      if (this.taskInfo.Status == -1 || this.taskInfo.Status == 2) {
        this.showRestartRustDetectorTask = true
      } else {
        this.$message({
          type: 'info',
          message: '任务正在运行中!'
        })
      }
    },
    onRestartTaskSuccess() {
      this.getTaskInfo()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.rust-task-detail {
  @include adaptation(
    (
      --rust-task-detail-result-item-margin-bottom: 6px,
      --rust-task-detail-label-item-margin-right: 8px,
      --rust-task-detail-label-item-margin-bottom: 8px,
    )
  );
  --rust-task-detail-min-height: var(--base-main-router-body-avaliable-height);

  .common-bg-plate {
    min-height: var(--rust-task-detail-min-height);

    .labels {
      .el-tag {
        margin-right: var(--rust-task-detail-label-item-margin-right);
        margin-bottom: var(--rust-task-detail-label-item-margin-bottom);
      }
    }

    .result-list {
      .el-alert {
        width: 100%;
        margin-bottom: var(--rust-task-detail-result-item-margin-bottom);
      }
    }
  }
}
</style>
